module.exports = __webpack_public_path__ + "static/media/31_plantilla_cuadrada_combo_simple_cf_gaseosas_pet_2_5_sp.43b2aa51.png";